import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { selectActiveRecipe } from 'src/state/recipe/selectors';
import ShowRecipe from './presenter';
import Types from 'Types';
import { withRouter } from 'react-router-dom';
import { actions as recipeActions } from 'src/state/recipe';

interface State {

}

const mapStateToProps = (state: Types.RootState, ownProps: State) => ({
  recipe: selectActiveRecipe(state)
});

const mapDispatchToProps = (dispatch: Dispatch<Types.RootAction>) => bindActionCreators({
  fetchRecipe: recipeActions.fetchRecipe.request
}, dispatch);

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ShowRecipe));